export default __webpack_public_path__ + "static/media/Avatar-21.f442ec0d.png";